import React, { useCallback } from 'react'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { useDispatch } from 'react-redux'
import { FetchContractorSelfie } from 'src/constants/actionTypes'
import { handleApiError } from 'src/utils/errorHandlers'
import { Button } from 'src/components/shared/Button'

interface Props {
  contractorId: string
  stepId: string
}

export const DownloadSelfieButton = ({ contractorId, stepId }: Props) => {
  const dispatch = useDispatch()

  const [isSelfieDownloading, setIsSelfieDownloading] = React.useState(false)

  const handleClickDownloadSelfie = useCallback(async () => {
    setIsSelfieDownloading(true)

    try {
      const buffer: ArrayBuffer = await createAsyncAction(
        dispatch,
        FetchContractorSelfie.request({
          contractorId,
          stepId,
        }),
      )

      const blob = new Blob([buffer], { type: 'image/jpeg' })

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${contractorId}_selfie.jpg`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (err) {
      handleApiError(err)
    }

    setIsSelfieDownloading(false)
  }, [contractorId, stepId])

  return (
    <Button
      size="small"
      color="grey"
      loading={isSelfieDownloading}
      onClick={handleClickDownloadSelfie}
    >
      Download
    </Button>
  )
}
